import React from 'react';
import { consultants } from '../../data/consultants';
import { ConsultantCard } from '../consultants/ConsultantCard';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
export function TeamPreview() {
  return <section className="bg-white py-24 md:py-32" data-id="element-298" data-mp="3udgmrf7jlrzl">
      <div className="container-page" data-id="element-299" data-mp="38i11a594srr">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-300" data-mp="376u51gif4wf">
          <SectionHeading kicker="Our consultants" title="The people who lead your search." intro="Each engagement is led personally by one of our executive search consultants." data-id="element-301" data-mp="3ldbihdxnb9pn" />
          <Button to="/consultants" variant="outline" arrow className="self-start md:self-auto" data-id="element-302" data-mp="3bj1nrpl8dzbr">
            Meet the team
          </Button>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-303" data-mp="19qn8kya2n8z1">
          {consultants.map(c => <ConsultantCard key={c.slug} consultant={c} data-id="element-304" data-mp="1enwui3y952i4" />)}
        </div>
      </div>
    </section>;
}